import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lancasterNhConfig } from "./data";

export default function LancasterNhPage() {
  return <CityPageTemplate config={lancasterNhConfig} />;
}